export function numberFormat(value: number, digits: number = 0): string {
  return value.toFixed(digits);
}
